import Link from 'next/link'
import React, { FC, ImgHTMLAttributes } from 'react'

import { useSelector } from 'react-redux'

import { isAuthorized } from '~/state/modules/user'

import ROUTES from '~/constants/routes'

const Logo: FC<ImgHTMLAttributes<HTMLImageElement>> = ({
  src,
  width = 70,
  ...props
}) => {
  const isAuth = useSelector(isAuthorized)

  return (
    <>
      {isAuth && (
        <Link href={ROUTES.dashboard}>
          <img
            src={src || '/static/images/logo.png'}
            alt="Logo"
            style={{ cursor: 'pointer' }}
            width={width}
            {...props}
          />
        </Link>
      )}
    </>
  )
}

export default Logo
